import { Card, Flex, Skeleton, Typography } from 'antd';
import TaskInfo from 'components/TaskInfo';
import { useTranslation } from 'react-i18next';
import { renderInfoValue } from 'utils/helpers';

const { Text, Title } = Typography;

interface PackageCount {
  notShipped?: number;
  shipped?: number;
  delivered?: number;
  invoiceUploaded?: number;
}

export interface PackageCountWidgetProps extends PackageCount {
  isLoading: boolean;
}

const PackageCountWidget = ({
  shipped,
  delivered,
  invoiceUploaded,
  isLoading,
}: PackageCountWidgetProps) => {
  const { t } = useTranslation();
  const renderTaskInfoHeader = (header: string) => {
    return <Text style={{ fontSize: '14px', fontWeight: 400 }}>{header}</Text>;
  };

  const renderTaskInfoValue = (value: string) => {
    return (
      <Title
        level={3}
        style={{ fontSize: '24px', fontWeight: 700, marginTop: 8 }}
      >
        {renderInfoValue(value, '0')}
      </Title>
    );
  };

  if (isLoading) {
    return <PackageCountSkeleton />;
  }

  return (
    <Card
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.02)' }}
      styles={{ body: { padding: 14, height: '100%' } }}
    >
      <Flex
        wrap={'wrap'}
        align={'center'}
        style={{ rowGap: 20, height: '100%' }}
      >
        <TaskInfo
          renderHeader={() =>
            renderTaskInfoHeader(
              t('packageTrackerDashboard.packageStatus.shipping'),
            )
          }
          renderValue={() => renderTaskInfoValue(shipped?.toString() ?? '0')}
        />
        <TaskInfo
          renderHeader={() =>
            renderTaskInfoHeader(
              t('packageTrackerDashboard.packageStatus.delivered'),
            )
          }
          renderValue={() => renderTaskInfoValue(delivered?.toString() ?? '0')}
        />
        <TaskInfo
          renderHeader={() =>
            renderTaskInfoHeader(
              t('packageTrackerDashboard.packageStatus.invoiceUploaded'),
            )
          }
          renderValue={() =>
            renderTaskInfoValue(invoiceUploaded?.toString() ?? '0')
          }
        />
      </Flex>
    </Card>
  );
};

function PackageCountSkeleton() {
  return (
    <Card
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.02)' }}
      styles={{ body: { padding: 14, height: '100%' } }}
    >
      <Flex wrap={'wrap'} justify="flex-start" style={{ rowGap: 20 }}>
        {[...Array(4)].map((_, index) => (
          <Flex key={index} vertical style={{ flexBasis: '48%' }}>
            <Skeleton.Button active style={{ width: '', height: 25 }} />
            <Skeleton.Button active style={{ marginTop: 8 }} />
          </Flex>
        ))}
      </Flex>
    </Card>
  );
}

export default PackageCountWidget;
